import React, { useState, useEffect, useRef } from "react";
import toast from "react-hot-toast";
import { FaPlus } from "react-icons/fa6";
import { FaArrowLeft, FaArrowRight } from "react-icons/fa";
import { MdOutlineFileDownload } from "react-icons/md";

import buttonStyles from "../../../../styles/Button.module.css";
import menuStyle from "../../../../styles/Menu.module.css";
import styles from "./../tooltip.module.css";
import "./usuarios.css";

import CreateUser from "./CreateUser";
import SearchBar from "../SearchBar";
import TableOptionCheck from "../Productos/TableOptionCheck";
import UsuariosTable from "./UsuariosTable";
import * as api from "helper/helper";
import { PermissionsForSection } from "../auth";
import { Sections } from "../../data/navItem";
import FilterButton from "../FilterButton/FilterButton";
import PagedFetch, {
  buildPageButtonsInfo,
  Init,
} from "../../helperFunctions/PagedFetch";
import { format } from "date-fns";
import { handleStatus } from "../../helperFunctions/helpers";
import ExportCSV from "../ExportCSV";

export default function UsuariosCatalogo({ subSection }) {
  const Menus = {
    Departamentos: 0,
    NivelesUsuario: 1,
    Roles: 2,
    Status: 3,
  };

  const StatusValues = {
    Activo: 0,
    Inactivo: 1,
  };

  const createUsuariosRef = useRef();
  const filtrosRef = useRef([]);
  const csvRef = useRef();
  const [modalData, setModalData] = useState(null);
  const [isLoading, setIsLoading] = useState(false);

  const [permissions, setPermissions] = useState({
    canCreate: true,
    canEdit: true,
    canVerDetalle: true,
  });

  const [usuarios, setUsuarios] = useState({});

  const [status, setStatus] = useState([
    {
      nombre: "Activo",
      value: StatusValues.Activo,
      id: 1,
      pos: 0,
      checked: false,
    },
    {
      nombre: "Inactivo",
      value: StatusValues.Inactivo,
      id: 2,
      pos: 1,
      checked: false,
    },
    //  { nombre: "Draft", value: "draft", id: 3 },
  ]);

  const [filtros] = useState([
    { type: Menus.Departamentos, name: "Departamentos" },
    { type: Menus.NivelesUsuario, name: "Niveles Usuario" },
    { type: Menus.Roles, name: "Roles" },
    {
      type: Menus.Status,
      name: "Estatus",
    },
    /* { type: "add_filter", name: "Agregar filtro" },*/
  ]);

  /** FILTERS */
  const [departamentos, setDepartamentos] = useState([]);
  const [nivelesUsuario, setNivelesUsuario] = useState([]);
  const [roles, setRoles] = useState([]);

  /** PAGING */
  const [searchCriteria, setSearchCriteria] = useState({});
  const [pageButtons, setPageButtons] = useState([Init.Vars.PageButtons]);

  ///start changes CLASS
  const pagingInfoRef = useRef(new PagedFetch());
  const [responsePagingInfo, setResponsePagingInfo] = useState({
    ...Init.Vars.ResponsePagingInfo,
  });

  const fetchData = async (resetPageNumber = true) => {
    setIsLoading(true);
    let criteria = searchCriteria;
    if (resetPageNumber) {
      /// reset pag info
      pagingInfoRef.current.resetPageInfo();
    }

    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    const responseDepa = await api.departamentos().catch((error) => {
      toast.error("Error al pedir departamentos.");
      setIsLoading(false);
    });
    if (!responseDepa) return;

    setDepartamentos(responseDepa.data);

    const responseNivelesUsuario = await api
      .nivelesUsuarios()
      .catch((error) => {
        toast.error("Error al pedir NivelesUsuario.");
        setIsLoading(false);
      });
    if (!responseNivelesUsuario) return;

    setNivelesUsuario(responseNivelesUsuario.data);

    const responseRoles = await api.roles().catch((error) => {
      toast.error("Error al pedir roles.");
      setIsLoading(false);
    });
    if (!responseRoles) return;

    setRoles(responseRoles.data);

    setIsLoading(false);
  };

  useEffect(() => {
    fetchData();

    const newPermissions = PermissionsForSection(Sections.Usuarios);
    setPermissions(newPermissions);
  }, []);

  function createUser(event) {
    console.log(event);
    loadItem({});
  }

  function reloadUsuarios() {
    fetchData(false);
  }

  function loadItem(item) {
    if (!permissions.canVerDetalle) return;

    console.log(createUsuariosRef);

    setModalData(item);

    createUsuariosRef.current.toggleModal();
  }

  /**
   * Search handler
   */
  const onChangeSearchText = (e) => {
    console.log("text search change " + e);

    let criteria = searchCriteria;

    criteria["texto"] = e;
    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);
  };

  ///
  function clearCallback(item) {
    filtros.forEach((value, index) => {
      if (
        value.type === Menus.Departamentos &&
        item.type === Menus.Departamentos
      ) {
        clearDepartamentoFilter();
      } else if (
        value.type === Menus.NivelesUsuario &&
        item.type === Menus.NivelesUsuario
      ) {
        clearNivelesFilter();
      } else if (value.type === Menus.Roles && item.type === Menus.Roles) {
        clearRolesFilter();
      } else if (value.type === Menus.Status && item.type === Menus.Status) {
        clearStatusFilter();
      }
    });
  }

  function clearDepartamentoFilter() {
    departamentos.forEach((item) => {
      item.checked = false;
    });
    setDepartamentos(departamentos.slice());

    updateDepartamentoCriteria([]);

    filtrosRef.current[Menus.Departamentos].hideMenu();
  }

  const handleDepartamentosClick = (event, item, options) => {
    let criteria = searchCriteria;
    let departamentoIds = criteria["DepartamentoIds"] ?? [];
    ///
    item.checked = event.currentTarget.checked;

    let itemId = item.id;
    if (event.currentTarget.checked && !departamentoIds.includes(item.id)) {
      departamentoIds.push(itemId);
    } else if (
      !event.currentTarget.checked &&
      departamentoIds.includes(item.id)
    ) {
      departamentoIds = departamentoIds.filter((f) => f !== itemId);
    }

    updateDepartamentoCriteria(departamentoIds);
  };

  const updateDepartamentoCriteria = (departamentoIds) => {
    let criteria = searchCriteria;

    criteria["DepartamentoIds"] = departamentoIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Departamentos;
    });

    if (index === -1) {
      return;
    }
    var depasNames = "";
    if (departamentoIds.length > 0) {
      //
      const depas = departamentos.filter((currItem) => {
        return departamentoIds.includes(currItem.id);
      });

      depasNames = depas
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(depasNames);
  };

  function clearNivelesFilter(s) {
    nivelesUsuario.forEach((item) => {
      item.checked = false;
    });

    setNivelesUsuario(nivelesUsuario.slice());

    updateNivelesCriteria([]);

    filtrosRef.current[Menus.NivelesUsuario].hideMenu();
  }

  const handleNivelesUsuarioClick = (event, item, options) => {
    let criteria = searchCriteria;
    let nivelUsuarioIds = criteria["NivelUsuarioIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !nivelUsuarioIds.includes(item.id)) {
      nivelUsuarioIds.push(itemId);
    } else if (
      !event.currentTarget.checked &&
      nivelUsuarioIds.includes(item.id)
    ) {
      nivelUsuarioIds = nivelUsuarioIds.filter((f) => f !== itemId);
    }

    updateNivelesCriteria(nivelUsuarioIds);
  };

  const updateNivelesCriteria = (nivelUsuarioIds) => {
    let criteria = searchCriteria;

    criteria["NivelUsuarioIds"] = nivelUsuarioIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.NivelesUsuario;
    });

    if (index === -1) {
      return;
    }
    var nivelesNames = "";
    if (nivelUsuarioIds.length > 0) {
      //
      const niveles = nivelesUsuario.filter((currItem) => {
        return nivelUsuarioIds.includes(currItem.id);
      });

      nivelesNames = niveles
        .map(function (depa) {
          return depa.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(nivelesNames);
  };

  const clearRolesFilter = () => {
    roles.forEach((item) => {
      item.checked = false;
    });

    setRoles(roles.slice());

    updateRolesCriteria([]);

    filtrosRef.current[Menus.Roles].hideMenu();
  };

  const handleRolesClick = (event, item, options) => {
    let criteria = searchCriteria;
    let rolIds = criteria["RolIds"] ?? [];

    let itemId = item.id;
    if (event.currentTarget.checked && !rolIds.includes(item.id)) {
      rolIds.push(itemId);
    } else if (!event.currentTarget.checked && rolIds.includes(item.id)) {
      rolIds = rolIds.filter((f) => f !== itemId);
    }

    updateRolesCriteria(rolIds);
  };

  const updateRolesCriteria = (rolIds) => {
    let criteria = searchCriteria;
    criteria["RolIds"] = rolIds;
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Roles;
    });

    if (index === -1) {
      return;
    }
    var rolesNames = "";
    if (rolIds.length > 0) {
      //
      const rols = roles.filter((currItem) => {
        return rolIds.includes(currItem.id);
      });

      rolesNames = rols
        .map(function (rol) {
          return rol.nombre;
        })
        .join(", ");
    }

    filtrosRef.current[index].toka(rolesNames);
  };

  const clearStatusFilter = () => {
    status.forEach((item) => {
      item.checked = false;
    });

    setStatus(status.slice());

    updateStatusCriteria(undefined);

    filtrosRef.current[Menus.Status].hideMenu();
  };

  const handleStatusClick = (event, item, options) => {
    item.checked = !item.checked;

    const isActivo = status.find((item) => {
      return item.value === StatusValues.Activo && item.checked;
    })?.checked;
    const isInactivo = status.find((item) => {
      return item.value === StatusValues.Inactivo && item.checked;
    })?.checked;

    let checked = isActivo;
    if (!(isActivo ^ isInactivo)) {
      //delete criteria["isActivo"];
      checked = undefined;
    } else {
      //let checked = isActivo;
      if (isInactivo) {
        checked = false;
      }
      //criteria["isActivo"] = checked;
    }

    updateStatusCriteria(checked);
  };

  const updateStatusCriteria = (statusValue) => {
    let criteria = searchCriteria;
    if (statusValue === undefined) {
      delete criteria["isActivo"];
    } else {
      criteria["isActivo"] = statusValue;
    }
    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);

    searchFetchData(criteria);

    // set text of filter -
    const index = filtros.findIndex((currItem) => {
      return currItem.type === Menus.Status;
    });

    if (index === -1) {
      return;
    }
    var statusNames = "";
    //
    const statuses = status.flatMap((currItem, index) => {
      return currItem.checked ? currItem.nombre : [];
    });

    statusNames = statuses.join(", ");

    filtrosRef.current[index].toka(statusNames);
  };

  const searchFetchData = async (criteria) => {
    setIsLoading(true);
    const response = await api.searchUsuario(criteria).catch((error) => {
      toast.error("Error al buscar Usuarios.");
      setIsLoading(false);
    });
    if (!response) return;

    const { totalPages, count, isFirstPage, isLastPage } = response.data;

    const { rangePage, newPageNumber } = buildPageButtonsInfo(response.data);
    pagingInfoRef.current.updatePageNumber(newPageNumber);

    setPageButtons(rangePage);

    setResponsePagingInfo({
      count,
      isFirstPage,
      isLastPage,
      pageNumber: newPageNumber,
      totalPages,
    });

    setUsuarios(response.data.subset);

    setIsLoading(false);
  };

  const previousPageState = responsePagingInfo.isFirstPage
    ? "disabled disable-paging-btn"
    : "";
  const nextPageState = responsePagingInfo.isLastPage
    ? "disabled disable-paging-btn"
    : "";

  function goPreviousPage() {
    let page = pagingInfoRef.current.pageNumber();
    page -= 1;
    goToPage(page);
  }

  function goNextPage() {
    let page = pagingInfoRef.current.pageNumber();
    page += 1;
    goToPage(page);
  }

  function goToPage(pageNumber) {
    let criteria = searchCriteria;
    pagingInfoRef.current.updatePageNumber(pageNumber);
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function handleSortChange({ sortBy, sortAsc }) {
    if ((sortBy?.length ?? 0) === 0) {
      return;
    }
    let criteria = searchCriteria;
    criteria["sortBy"] = sortBy;
    criteria["sortAsc"] = sortAsc === "asc";

    setSearchCriteria(criteria);

    /// reset pag info
    pagingInfoRef.current.resetPageInfo();
    criteria = pagingInfoRef.current.buildFetch(criteria);
    searchFetchData(criteria);
  }

  function generateFile(event) {
    //TODO: generar CSV con los filtros seleccionados

    const csvString = [
      [
        "Id",
        "Nombre",
        "Fecha nacimiento",
        "Email",
        "Departamento",
        "Nivel",
        "Estatus",
      ], // Specify your headers here
      ...usuarios.map((item) => {
        const bDay = format(item.fechaNacimiento, "dd/MM/yy");

        return [
          item.id ? item.id : "",
          `${item.nombre ? item.nombre : ""} ${
            item.apellidoPaterno ? item.apellidoPaterno : ""
          } ${item.apellidoMaterno ? item.apellidoMaterno : ""}`,
          bDay,
          item.departamento?.nombre,
          item.nivelUsuario?.nombre,
          handleStatus(item).text,
        ];
      }),
    ] // Map your data fields accordingly
      .map((row) => row.join(","))
      .join("\n");

    csvRef.current.downloadCSV(csvString, "usuarios.csv");
  }

  return (
    <div className="card recent-sales overflow-auto">
      <ExportCSV ref={csvRef} />
      {/** */}
      <div className="separator"></div>
      <div className="">
        <div
          className="container-fluid"
          style={{ paddingLeft: "20px", paddingRight: "20px" }}
        >
          <div className="header">
            <SearchBar
              onChange={(e) => onChangeSearchText(e)}
              placeholder="Buscar por Id y/o Nombre..."
            />
          </div>
          <div
            style={{
              display: "flex",
              justifyContent: "end",
              marginTop: "10px",
              gap: "10px",
            }}
          >
            <button
              className={`btn btn-info ${styles.tooltip}`}
              onClick={(event) => generateFile(event)}
              style={{ marginLeft: "0px" }}
              disabled={isLoading}
            >
              <div>
                <span className={`${styles.tooltiptext}`}>Descargar CSV</span>
                <MdOutlineFileDownload />
              </div>
            </button>
            <button
              className="btn btn-primary"
              onClick={createUser}
              hidden={!permissions.canCreate}
            >
              <div className={buttonStyles.icon_button}>
                <FaPlus />
                Crear Usuario
              </div>
            </button>
          </div>

          <div
            className="btn-group1"
            style={{ display: "flex", columnGap: "6px" }}
          >
            {filtros.map((item, index) => {
              return (
                <>
                  <FilterButton
                    key={index}
                    ref={(el) => (filtrosRef.current[index] = el)}
                    name={item.name}
                    clearCallback={(ble) => clearCallback(item)}
                  >
                    <ul
                      className={`dropdown-menu ${menuStyle.height_50_scroll}`}
                      aria-labelledby="dropdownMenuClickableInside"
                    >
                      {item.type === Menus.Departamentos &&
                        departamentos.map((item, index) => {
                          return (
                            <TableOptionCheck
                              key={index}
                              item={item}
                              onClick={handleDepartamentosClick}
                            />
                          );
                        })}
                      {item.type === Menus.NivelesUsuario &&
                        nivelesUsuario.map((item, index) => {
                          return (
                            <TableOptionCheck
                              key={index}
                              item={item}
                              onClick={handleNivelesUsuarioClick}
                            />
                          );
                        })}
                      {item.type === Menus.Roles &&
                        roles.map((item, index) => {
                          return (
                            <TableOptionCheck
                              key={index}
                              item={item}
                              onClick={handleRolesClick}
                            />
                          );
                        })}

                      {item.type === Menus.Status &&
                        status.map((item, index) => {
                          return (
                            <TableOptionCheck
                              key={index}
                              item={item}
                              onClick={handleStatusClick}
                            />
                          );
                        })}
                    </ul>
                  </FilterButton>
                </>
              );
            })}
          </div>
        </div>
      </div>

      {/** */}
      <nav aria-label="Page navigation example" style={{ marginRight: "20px" }}>
        <ul className="pagination justify-content-end">
          <li
            className={`page-item ${previousPageState}`}
            onClick={(event) => goPreviousPage()}
          >
            <a
              className="page-link"
              href="#"
              tabIndex="-1"
              aria-disabled={"true"}
            >
              <FaArrowLeft />
            </a>
          </li>

          {pageButtons.map((item) => {
            let page = pagingInfoRef.current.pageNumber();
            let disabled =
              page === item.pageNumber ? "disabled disable-paging-btn" : "";
            return (
              <li
                className={`page-item ${disabled}`}
                onClick={(event) => goToPage(item.pageNumber)}
              >
                <a className="page-link" href="#">
                  {item.name}
                </a>
              </li>
            );
          })}
          <li
            className={`page-item ${nextPageState}`}
            onClick={(event) => goNextPage()}
          >
            <a className="page-link" href="#">
              <FaArrowRight />
            </a>
          </li>
        </ul>
      </nav>

      <div className="card-body">
        <UsuariosTable
          items={usuarios}
          openItem={loadItem}
          handleSortChange={handleSortChange}
          isLoading={isLoading}
        />
      </div>

      <CreateUser
        ref={createUsuariosRef}
        item={modalData}
        reloadUsuarios={reloadUsuarios}
      />
    </div>
  );
}
